@if (showLabel) {
  <label class="mb-2 fw-normal d-block">
    {{ prefix + '-titel' | fromDictionary }}
    @if (max < 10 && max > -1 && max !== 0) {
      -
      <span class="text-warning">{{ max }} {{ prefix + '-beschikbaarheid-waarschuwing-suffix' | fromDictionary }}</span>
    }
  </label>
}

<div class="amount-chooser">
  <button [disabled]="amount === min" class="button button--secondary button-icon button--xs" (click)="subtract()" aria-label="Remove 1">
    <app-icon anchor="icon-minus"></app-icon>
  </button>
  <div class="button button-outline button--secondary amount-chooser__amount" [class.is--disabled]="amount === min && maxReached">
    <input
      type="number"
      [disabled]="amount === min && maxReached"
      [formControl]="amountField"
      placeholder="Aantal"
      (change)="amountChange(+(amountInput.value || 0))"
      #amountInput
    />
    <!-- <span class="chip me-2" [class.chip--muted]="amount === min && maxReached">{{ amount }}</span>
    <span>{{ 'product-aantal-suffix' | fromDictionary }}</span> -->
  </div>
  <button [disabled]="maxReached" class="button button--secondary button-icon button--xs" (click)="add()" aria-label="Add 1">
    <app-icon anchor="icon-plus"></app-icon>
  </button>
</div>

@if (maxReached && showMaxLabel) {
  <div class="p-0 mt-1 alert alert--warning type-body-sm">
    {{ 'product-max-bereikt' | fromDictionary }}
  </div>
}

@if (updatedAmountToMaxAvailable) {
  <div class="mt-2 alert alert--warning type-body-sm">
    {{ 'melding-aantal-tot-max-beschikbaar-geupdatet' | fromDictionary }}
  </div>
}
